import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spin from 'antd/lib/spin';
import {
  fetchReportActions,
  selectResultState
} from '../ducks';
import {
  apiCallIds
} from '../api'
import translate from 'react-i18next/dist/commonjs/translate';
import { mapFilterToEndpointParams } from '../../../common/utils/helpers';
import { ReportTransactions } from '../components'
import { selectIsInProgress } from '../../spinner/ducks';

const mapStateToProps = state => ({
  result: selectResultState(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_REPORT)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchReport: fetchReportActions.request
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class ReportTransactionsContainer extends Component{
  static propTypes = {
    t: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    result: PropTypes.object,
  };

  componentDidMount(){
    console.log('control job')
    this.props.actions.fetchReport()
  }


  render(){
    const {
      result,
      isLoading,
      t
    } = this.props

    if (!result) {
      return (
        <Spin spinning={true}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <Spin spinning={isLoading}>
        <div className="panel-wrapper">
          
            <ReportTransactions
              result={result}
              isLoading={isLoading}
            >
            </ReportTransactions>

        </div>
      </Spin>
      
      
      
    )

  }
}


// WEBPACK FOOTER //
// ./src/features/transactions/containers/ReportTransactionsContainer.js